import { 
  // useState, 
  useEffect 
} from "react";
// import { useDispatch } from "react-redux";
import Snackbar from "../../components/exchange-componnets/snakBar";
// import { showWarningSnackbar } from "../../redux/actions/registartionAction";
// import { validateEmail } from "../../constants/regex";
import mautic from 'mautic-tracking';
import { Helmet } from "react-helmet";

const ContactsPage = () => {
  // const dispatch = useDispatch();
  // const [fullName, setFullName] = useState("");
  // const [company, setCompany] = useState("");
  // const [email, setEmail] = useState("");
  // const [phone, setPhone] = useState("");
  // const [message, setMessage] = useState("");
  // const [sended, setSended] = useState(false);
  // const [buttonEnabled, setButtonEnabled] = useState(false);

  // const sendFunction = () => {
  //   if (!fullName && !email && !company && !phone && !message) {
  //     dispatch(showWarningSnackbar("Please fill all input fields"));
  //   }
  // };

  useEffect(() => {
    mautic.pageView({});
  }, []);

  // useEffect(() => {
  //   validateEmail(email) &&
  //     /^.{2,20}$/gi.test(fullName.trim()) &&
  //     /^.{2,80}$/gi.test(company.trim()) &&
  //     /^.{2,80}$/gi.test(phone.trim()) &&
  //     /^.{2,80}$/gi.test(message.trim())
  //     ? setButtonEnabled(true)
  //     : setButtonEnabled(false);
  // }, [fullName, company, phone, message, email]);

  return (
    <div className="contacts">
      <Helmet>
        <title>Contact | Traditional Real Estate Services - DIBS Capital</title>
        <meta name="description" content="DIBS Capital is powering the world's digital assets: end-to-end tokenization platform for real estate- and equity-backed securities."></meta>
        <meta name="Keywords" content="traditional real estate services"></meta>
      </Helmet>
      <Snackbar />
      <main className="main contacts-page">
        <section className="section-contact">
          {/* <h1 className="title">Contact</h1>
          <p className="text">
            <span>Fill the form to contact us and We will respond</span>
            <span className="text--newlined-mobile">
              {" "}
              You as soon as possible
            </span>
          </p> */}
          <div className="contact-box">
            {/* <div className="form-wrapper">
              <div className="form-container">
                <h2>Send Us a Message</h2>
                <form
                  autoComplete="false"
                  method="post"
                  action="https://ams.solidblock.co/form/submit?formId=3"
                  id="mauticform_contactus"
                  data-mautic-form="contactus"
                  encType="multipart/form-data"
                >
                  <div
                    className="form form-validation-js validate"
                    id="mc-embedded-subscribe-form"
                    data-form-name="contact"
                  >
                    <div className="form-group">
                      <div className="form-control">
                        <span className="form__message">
                          <p className="error" data-error-id="mauticform[first_name]"></p>
                        </span>
                        <input
                          onChange={(e) => {
                            setFullName(e.target.value)
                            setSended(false)
                          }}
                          value={fullName}
                          className="form__field"
                          type="text"
                          name="mauticform[first_name]"
                          placeholder="Your name"
                          required
                          id="mauticform_input_contactus_first_name"
                        />
                        <span className="form__field-placeholder">Full name</span>
                      </div>
                      <div className="form-control">
                        <span className="form__message">
                          <p className="error" data-error-id="mauticform[email_address]"></p>
                        </span>
                        <input
                          onChange={(e) => {
                            setEmail(e.target.value)
                            setSended(false)
                          }}
                          value={email}
                          className="form__field"
                          type="email"
                          name="mauticform[email_address]"
                          placeholder="Your E-mail"
                          required
                          id="mauticform_input_contactus_email_address"
                        />
                        <span className="form__field-placeholder">Email</span>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="form-control">
                        <span className="form__message">
                          <p className="error" data-error-id="mauticform[phone_number]"></p>
                        </span>
                        <input
                          onChange={(e) => {
                            setPhone(e.target.value)
                            setSended(false)
                          }}
                          value={phone}
                          className="form__field"
                          type="text"
                          name="mauticform[phone_number]"
                          placeholder="Your Phone"
                          required
                          id="mauticform_input_contactus_phone_number"
                        />
                        <span className="form__field-placeholder">Phone</span>
                      </div>
                      <div className="form-control">
                        <span className="form__message">
                          <p className="error" data-error-id="mauticform[company]"></p>
                        </span>
                        <input
                          onChange={(e) => {
                            setCompany(e.target.value)
                            setSended(false)
                          }}
                          value={company}
                          className="form__field"
                          type="text"
                          name="mauticform[company]"
                          placeholder="Company"
                          required
                          id="mauticform_input_contactus_company"
                        />
                        <span className="form__field-placeholder">Company</span>
                      </div>
                    </div>
                    <div className="form-group form-group--textarea form-group--full-width">
                      <div className="form-control">
                        <span className="form__message">
                          <p className="error" data-error-id="mauticform[your_message]"></p>
                        </span>
                        <textarea
                          onChange={(e) => {
                            setMessage(e.target.value)
                            setSended(false)
                          }}
                          value={message}
                          className="form__field"
                          name="mauticform[your_message]"
                          placeholder="Your Message"
                          required
                          id="mauticform_input_contactus_your_message"
                        ></textarea>
                        <span className="form__field-placeholder">
                          Your message
                        </span>
                      </div>
                    </div>
                    <button
                      type="submit"
                      name="mauticform[submit]"
                      id="mauticform_input_contactus_submit"
                      value=""
                      onClick={() => sendFunction()}
                      className="form__submit button"
                      disabled={!buttonEnabled}
                    >
                      <span className="button__text-block">
                        {!buttonEnabled ? "Fill in all fields correctly" : "Send Message"}
                      </span>
                      {sended ? null : <span className="button__icon-block">
                        <i className="button__icon"></i>
                      </span>}
                    </button>
                  </div>
                  <input type="hidden" name="mauticform[last_name]" id="mauticform_input_contactus_last_name" value="" />
                  <input type="hidden" name="mauticform[formId]" id="mauticform_contactus_id" value="3" />
                  <input type="hidden" name="mauticform[return]" id="mauticform_contactus_return" value="" />
                  <input type="hidden" name="mauticform[formName]" id="mauticform_contactus_name" value="contactus" />
                </form>
              </div>
              <div className="result-container">
                <span className="icon icon--successful"></span>
                <h3 className="result-wrapper__title">
                  Thank you for submission!
                </h3>
                <p className="result-wrapper__description">
                  We will contact you as soon as possible
                </p>
                <a className="button" href="/" type="submit">
                  <span className="button__text-block">Done</span>
                  <span className="button__icon-block">
                    <i className="button__icon"></i>
                  </span>
                </a>
              </div>
            </div> */}
            <div className="contacts">
              <h2>Contact Info</h2>
              <div className="contacts__info">
                <address className="contacts__item">
                  500 Washington St, San Francisco
                  <br />
                  CA 94111, United States
                  <br />
                  <a href="tel:972544584618">+972 54-458-4618</a>
                </address>
                <a className="contacts__item" href="mailto:contact@dibscapital.com">
                  contact@dibscapital.com
                </a>
              </div>
              <div className="contacts__socials">
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="contacts__socials-item"
                  href="https://www.linkedin.com/company/dibscapital/"
                >
                  <i className="icon icon--ln"></i>
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="contacts__socials-item"
                  href="https://www.facebook.com/dibscapital/"
                >
                  <i className="icon icon--fb"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="pipedriveWebForms form-box" data-pd-webforms="https://webforms.pipedrive.com/f/ckzyXaI1XVI2mdfCFw2yrsfjxWoP5nPH3Q4LNappJHp0EgTfnDufnIIiOCiTIAM45J"></div>
        </section>
      </main>
    </div>
  );
};

export default ContactsPage;